import { service } from "@server/client";
import type {
  RemoveGiftCardMutation,
  RemoveGiftCardMutationVariables,
} from "@server/gql/graphql";
import { removeGiftCardMutation } from "@server/queries/cart";

export const removeGiftCard = async (
  variables: RemoveGiftCardMutationVariables,
) => {
  try {
    const response = await service<
      RemoveGiftCardMutation,
      RemoveGiftCardMutationVariables
    >({
      query: removeGiftCardMutation,
      variables,
    });

    return response.removeGiftCard;
  } catch (error: any) {
    console.error("removeGiftCard error", error);
    return undefined;
  }
};
